import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import VueApollo from 'vue-apollo';
import ApolloClient from 'apollo-boost';
import { InMemoryCache } from 'apollo-cache-inmemory';
import VueI18n from 'vue-i18n';

Vue.config.productionTip = false;
Vue.use(VueApollo);
Vue.use(VueI18n);

require('@/sass/main.scss');

const data = require('./lang/messages.json');
const i18n = new VueI18n({
    locale: 'ja',
    messages: data
});

const client = new ApolloClient({
    uri: '/graphql',
    request: operation => {
        const token = localStorage.getItem('apollo-token');
        operation.setContext({
            headers: {
                authorization: token ? `Bearer ${token}` : ''
            }
        });
    }
});

client.defaultOptions.query = {
    fetchPolicy: 'no-cache'
};

const apolloProvider = new VueApollo({
    defaultClient: client,
    cache: new InMemoryCache()
});

// router.beforeEach((to, from, next) => {
//     console.log('global-before-each');
//     next();
// });

new Vue({
    router,
    store,
    vuetify,
    i18n,
    apolloProvider,
    render: h => h(App)
}).$mount('#app');
